export function getUsedSavedVehicles(options) {
    return new Promise((resolve, reject) => {
        axios.post('/api/saved-vehicles/used', options)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
export function getNewSavedVehicles(options) {
    return new Promise((resolve, reject) => {
        axios.post('/api/saved-vehicles/new', options)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
export function getMotabilitySavedVehicles(options) {
    return new Promise((resolve, reject) => {
        axios.post('/api/saved-vehicles/motability', options)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export default { getUsedSavedVehicles, getNewSavedVehicles, getMotabilitySavedVehicles };



// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/SavedVehiclesAPI.js